'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/spin/style/css.js
// module id = 270
// module chunks = 70144966829960